import { FadeIn } from "@/components/common/FadeIn";

const services = [
  {
    id: "gestion",
    title: "Ingeniería para Desarrollo de Gestión",
    image: "/icons/services/gestion.png",
    angle: 0,
  },
  {
    id: "asesorias",
    title: "Asesorías Tecnológicas",
    image: "/icons/services/asesorias.png",
    angle: 72,
  },
  {
    id: "clouding",
    title: "Clouding",
    image: "/icons/services/clouding.png",
    angle: 144,
  },
  {
    id: "licencias",
    title: "Arriendo de Licencias",
    image: "/icons/services/licencias.png",
    angle: 216,
  },
  {
    id: "especificos",
    title: "Ingeniería para Desarrollos Específicos",
    image: "/icons/services/especificos.png",
    angle: 288,
  },
];

export const Services = () => {
  return (
    <section id="servicios" className="py-20 md:py-28" data-testid="services-section">
      <div className="section-container">
        <FadeIn>
          <p className="text-xs uppercase tracking-[0.2em] text-slate-500" data-testid="services-kicker-text">
            Servicios
          </p>
          <h2 className="mt-3 text-base md:text-lg text-slate-600" data-testid="services-subheading-text">
            Nuestras capacidades principales organizadas en un mapa de servicios integrado.
          </h2>
        </FadeIn>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:hidden" data-testid="services-grid-mobile">
          {services.map((service, index) => (
            <FadeIn key={service.id} delay={0.06 * (index + 1)}>
              <article
                className="rounded-xl border border-[#BCD5EA] bg-white p-4"
                data-testid={`service-mobile-card-${service.id}`}
              >
                <div className="mx-auto h-36 w-36 overflow-hidden" data-testid={`service-mobile-image-frame-${service.id}`}>
                  <img
                    src={service.image}
                    alt={service.title}
                    className="h-full w-full object-contain mix-blend-multiply"
                    data-testid={`service-mobile-image-${service.id}`}
                  />
                </div>
                <h3 className="corporate-title-balance mt-7 text-sm text-[#005F92]" data-testid={`service-mobile-title-${service.id}`}>
                  {service.title}
                </h3>
              </article>
            </FadeIn>
          ))}
        </div>

        <FadeIn className="hidden lg:block" delay={0.15}>
          <div
            className="relative mt-12 min-h-[720px] rounded-2xl border border-[#BCD5EA] bg-gradient-to-b from-[#F6FAFF] to-[#EAF3FF]"
            data-testid="services-circular-diagram"
          >
            <div
              className="absolute left-1/2 top-1/2 h-[520px] w-[520px] -translate-x-1/2 -translate-y-1/2 rounded-full border-[4px] border-dashed border-[#70AFC1]/70"
              data-testid="services-circular-ring"
            />

            {services.map((service) => (
              <article
                key={service.id}
                className="absolute left-1/2 top-1/2 w-[240px] -translate-x-1/2 -translate-y-1/2"
                style={{
                  transform: `translate(-50%, -50%) rotate(${service.angle}deg) translateY(-260px) rotate(-${service.angle}deg)`,
                }}
                data-testid={`service-diagram-node-${service.id}`}
              >
                <div className="mx-auto flex h-[230px] w-[230px] items-center justify-center overflow-hidden" data-testid={`service-diagram-image-frame-${service.id}`}>
                  <img
                    src={service.image}
                    alt={service.title}
                    className="h-full w-full object-contain mix-blend-multiply"
                    data-testid={`service-diagram-image-${service.id}`}
                  />
                </div>
                <h3 className="corporate-title-balance mt-5 text-center text-xl text-[#005F92]" data-testid={`service-diagram-title-${service.id}`}>
                  {service.title}
                </h3>
              </article>
            ))}
          </div>
        </FadeIn>
      </div>
    </section>
  );
};
